import React from "react";
import "./index.css";
import { InfoCircleOutlined, SnippetsOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Routes } from "../../common/Routes";
import { Tooltip } from "antd";
import { getAppAccessTypeLink } from "../../common/AccessTypeLinks";
import { ApplicationAction, sendApplicationEvent } from "../matomoClient";
import { TooltipMessage } from "../../common/data/TooltipMsg";

function ApplicationListActions({ applicationUniqueName, applicationName, applicationURL }) {
  const { url: accessTypeURL, active: accessTypeURLActive } = getAppAccessTypeLink({
    accessTypeLink: applicationURL,
  });

  const _onClick = (e) => {
    if (accessTypeURLActive === false) {
      e.preventDefault();
    } else {
      sendApplicationEvent(ApplicationAction.GoAccessTypes, applicationName);
    }
  };

  const _onContextMenu = (e) => {
    if (accessTypeURLActive === false) {
      e.preventDefault();
      return false;
    }
  };

  return (
    <div className="appListActions">
      <Tooltip title={TooltipMessage.appInfoIcon(applicationName)}>
        <Link
          to={{ pathname: `${Routes.Applications.path}/${applicationUniqueName}/appInfo` }}
          onClick={() => {
            sendApplicationEvent(ApplicationAction.AppInfoAction, applicationName);
          }}
        >
          <InfoCircleOutlined className="appListActionsInfoIcon"/>
        </Link>
      </Tooltip>
      <Tooltip
        title={TooltipMessage.accessTypeIcon(applicationName)}
        placement="topRight"
      >
        <Link
          to={{ pathname: accessTypeURL }}
          className={
            accessTypeURLActive
              ? "appListActionsAccessTypeIcon"
              : "disabledAppListActionsAccessTypeIcon"
          }
          target="_blank"
          onClick={(e) => {
            _onClick(e);
          }}
          onContextMenu={(e) => _onContextMenu(e)}
        >
          <SnippetsOutlined/>
        </Link>
      </Tooltip>
    </div>
  );
}

export default ApplicationListActions;
